import styled, { css } from 'styled-components';
import { Field } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';
import { Overlay, Popup } from '@fluentui/react';

export const SkillsFindExpertContainer = styled.div`
  background: ${(props) => props.theme.skillsAccordionBackground};
  height: 100%;
  overflow-x: hidden;
`;

export const FindExpertTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  padding-left: 26px;
  padding-top: 26px;
  padding-bottom: 26px;
  border-bottom: 1px solid ${(props) => props.theme.skillsAccordionBorderColor};
  display: flex;
  justify-content: space-between;
  padding-right: 26px;

  margin-bottom: 10px;
`;

export const SkillsFindExpertContent = styled.div`
  padding: 0;
  padding-left: 1rem;
  padding-bottom: 0;
  padding-right: ${isMobile ? '1rem' : '2rem'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  overflow: auto;
  flex-grow: 1;
  max-height: 85vh;
  box-sizing: border-box;
  margin: 0;
  margin-top: 20px;

  @media (max-width: 710px) {
    min-height: 80vh;
    justify-content: flex-start;
    overflow-x: hidden;
  }
`;

export const StyledImage = styled.img`
  width: 75%;
  height: 75%;
  object-fit: cover;

  @media (max-width: 710px) {
    width: 48%;
  }
`;

export const FindExpertImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0.5rem;
  h1 {
    font-size: 16px;
    font-weight: 700;
  }
  padding-bottom: 2rem;

  @media (max-width: 710px) {
    width: 100%;
    margin-top: -40px;

    h1 {
      margin-top: 32px;
      font-size: 18px;
      font-weight: 700;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      color: ${(props) => props.theme.skillsMainTextColor} !important;
    }
  }
`;

export const DropdownStyled = styled(Field)`
  width: 100%;
`;

export const FindExpertHeading = styled.h1`
  font-size: 14px;
  padding: 5px;
  font-weight: 600;
  width: 100%;
  border-bottom: 2px solid #5b5fc7;
  margin-bottom: 5px;
`;

export const ExpertsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.5rem;

  [class*='ms-Persona-initials'] {
    height: 38px;
    width: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 5px;
    margin-top: 10px;
  }
`;

export const SkillExpertsList = styled.ul<{ appHost: string }>`
  list-style: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: scroll;
  overflow-x: hidden;
  height: auto;
  box-sizing: border-box;
  margin-bottom: 20px;
  @media (max-width: 710px) {
    width: 100svw;
    margin-left: auto;
    margin-right: auto;
    overflow-x: hidden;

    svg {
      margin-right: 5px;
    }
  }
`;

const clearAllMobileStyle = css`
  font-size: 17px !important;
  font-weight: 400;
  color: ${(props) => props.theme.skillsButtonsColor};
  cursor: pointer;
`;

export const ClearAllButton = styled.p<{
  isClearAllVisible?: string | true;
  isMobile?: boolean;
}>`
  ${({ isMobile, isClearAllVisible }) => {
    if (isMobile && !isClearAllVisible) {
      return 'pointer-events: none; color: transparent; margin-right: 2rem;';
    } else if (isMobile && isClearAllVisible) {
      return clearAllMobileStyle;
    } else {
      return 'font-size: 14px; font-weight: 600; color: #5b5fc7; cursor: pointer;';
    }
  }}
`;

export const ExpertTopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 5%;
  border-bottom: 1px solid ${(props) => props.theme.skillsAccordionBorderColor};

  h1 {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 5%;
    margin-left: 2rem;
  }
  svg,
  p {
    margin-bottom: 5%;
    margin-right: 2rem;
    cursor: pointer;
  }

  @media (max-width: 710px) {
    display: flex;
    align-items: center;

    h1 {
      font-size: 17px;
      margin-bottom: 5%;
    }
  }
`;

export const ExpertUserActionsContainer = styled.div`
  display: none;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-50%, -50%);
  height: fit-content;
`;

export const ExpertActionsContainer = styled.div`
  display: flex;
  margin-left: auto;
  height: 25px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  svg {
    cursor: pointer;
    display: ${isMobile ? 'block' : 'none'};
  }
`;

export const ExpertWidgetListItem = styled.li`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  &:hover {
    svg {
      cursor: pointer;
      display: block;
    }
  }
`;

export const MobileCallUserPopup = styled(Popup)`
  position: fixed;
  background-color: #000;
  z-index: 5;
  opacity: 0.5;
  width: 100vw;
  height: 100vh;
`;
export const MobileCallUserOverlay = styled(Overlay)`
  position: fixed;
  background: ${(props) => props.theme.skillsAccordionBackground};
  width: 80vw;
  height: 200px;
  display: flex;
  flex-direction: column;
  z-index: 10;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 15px;
  padding-left: 30px;
  padding-right: 30px;
`;

export const PlaceCallTextContainer = styled.div`
  h1 {
    font-size: 20px;
    color: ${(props) => props.theme.skillsButtonsColor};
    font-weight: 500;
  }
  p {
    color: ${(props) => props.theme.skillsButtonsColor};
  }
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  gap: 15px;
`;

export const PlaceCallActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  gap: 15px;
`;
